export default "__VITE_ASSET__120c24b6__"